export const Data = (data) => {
  return new Date(data).toLocaleDateString();
};
